import { getEndpoint } from "@api-routes/endpoint";

const OTP_VERIFICATION_MS_NAME = "otp-verification";

export const POST_CREATE_OTP_CODE_ROUTE = `${getEndpoint(OTP_VERIFICATION_MS_NAME)}otp`;

export const postVerificationCodeRoute = (otpUuid?: string) =>
    `${getEndpoint(OTP_VERIFICATION_MS_NAME)}otp/${otpUuid}/validate`;
